/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module VsLogsModule
 */

import {
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
} from '@angular/core';
import { L10nService } from '@vmw/ngx-vip';

import {
    VirtualServiceStateService,
} from 'ng/modules/virtual-service/services/virtual-service-state.service';
import { TVsLog } from '../../../vs-logs.types';
import { VsLogListExpandedContentStore } from './vs-log-list-expanded-content.store';

import * as l10n from './vs-log-list-expanded-content.l10n';
import './vs-log-list-expanded-content.component.less';

const { ENGLISH: dictionary, ...l10nKeys } = l10n;

/**
 * @description
 *     Component used for showing the communicating IPs in the log list expanded content.
 * @author Zhiqian Liu
 */
@Component({
    selector: 'vs-log-list-expanded-content',
    templateUrl: 'vs-log-list-expanded-content.component.html',
    providers: [VsLogListExpandedContentStore],
})
export class VsLogListExpandedContentComponent implements OnInit {
    /**
     * The log entry to be displayed with summary information in the expanded content.
     */
    @Input()
    public log: TVsLog;

    /**
     * Handler for opening a c-view to inspect the full log.
     */
    @Output()
    public readonly viewFullLog: EventEmitter<TVsLog> = new EventEmitter<TVsLog>();

    public readonly isSignificantLog$ = this.componentStore.isSignificantLog$;

    public readonly significantLog$ = this.componentStore.significantLog$;

    public readonly l10nKeys = l10nKeys;

    /**
     * Reference to the virtual service item instance.
     */
    public readonly vs: any;

    constructor(
        l10nService: L10nService,
        vsStateService: VirtualServiceStateService,
        public readonly componentStore: VsLogListExpandedContentStore,
    ) {
        l10nService.registerSourceBundles(dictionary);

        this.vs = vsStateService.virtualService;
    }

    /**
     * @override
     */
    public ngOnInit(): void {
        this.componentStore.setLogBasedOnType(this.log);
    }

    public handleViewFullLog(): void {
        this.viewFullLog.emit(this.log);
    }
}
